import { render, staticRenderFns } from "./veStuCaucusShow.vue?vue&type=template&id=53023b1a&scoped=true"
import script from "./veStuCaucusShow.vue?vue&type=script&lang=js"
export * from "./veStuCaucusShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53023b1a",
  null
  
)

export default component.exports